import React from "react";
import UploadProto from "./UploadProto";
import ServiceType from "./ServiceType";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import classes from "./ServiceSetup.module.css";

const ServiceSetup = ({ isFreezedByActivatedHaas, isHaasDaemonAIInitiated }) => {
    return (
        <Box className={classes.serviceSetupContainer}>
            <Typography variant="h6" color={isFreezedByActivatedHaas && "text.disabled"}>
                Service setup
            </Typography>
            <ServiceType disabled={isFreezedByActivatedHaas || isHaasDaemonAIInitiated} />
            <UploadProto isFreezedByActivatedHaas={isFreezedByActivatedHaas} />
        </Box>
    );
};

export default ServiceSetup;
